import React from 'react';
import styled from 'styled-components';
import { PropTypes } from 'prop-types';

const Holder = styled.div`
  position: relative;
  background-color: ${props => props.bg ? props.bg : props.theme.colours.white};
  @media( ${props => props.theme.breakpoints.sm} ) {
    ${props => props.largeBg && `background-color: ${props.largeBg}`};
  }
`;

const Inner = styled.div`
  max-width: calc( 1200px - 4rem );
  margin: 0 auto;
  padding: 4rem 2rem;
  background-color: ${props => props.innerBg ? props.innerBg : 'transparent'};
  @media( ${props => props.theme.breakpoints.sm} ) {
    padding: 8rem 4rem;
    padding-top: ${props => props.paddingTop ? '8rem' : '0'};
    padding-bottom: ${props => props.paddingBottom ? '8rem' : '0'};
  }
  > :first-child { margin-top: 0; }
  > :last-child { margin-bottom: 0; }
`;

function Container( props ) {

  return (
    <Holder
      bg={props.bg} largeBg={props.largeBg}>
      <Inner
        innerBg={props.innerBg}
        paddingTop={props.paddingTop}
        paddingBottom={props.paddingBottom}>{props.children}</Inner>
    </Holder>
  )
}

Container.propTypes = {
  bg: PropTypes.string,
  largeBg: PropTypes.string,
  innerBg: PropTypes.string,
  paddingTop: PropTypes.bool,
  paddingBottom: PropTypes.bool,
};

Container.defaultProps = {
  paddingTop: true,
  paddingBottom: true,
};

export default Container;
